import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_InertiaLink = _resolveComponent("InertiaLink")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_InertiaLink, {
            href: "/acl/groups/create",
            class: "block w-full mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить новую группу ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table, {
            data: _ctx.groups,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                "label-class-name": "weight-regular",
                "class-name": "text-dark",
                label: "Название"
              }),
              _createVNode(_component_el_table_column, {
                label: "",
                width: "250"
              }, {
                default: _withCtx(({ row }: { row: { id: Number } | any }) => [
                  _createVNode(_component_InertiaLink, {
                    href: '/acl/groups/' + row.id + '/edit',
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Редактировать")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["href"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.deleteGroup(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Удалить ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}